import { memo, useEffect, useMemo, type FunctionComponent } from 'react';
import { useLazyQuery } from '@apollo/client';
// Skillmore UI Components
import useQueryCounted from '@empathco/ui-components/src/hooks/useQueryCounted';
import CardsGrid from '@empathco/ui-components/src/components/CardsGrid';
// local imports
import { ADMIN_REPORTS_QUERY } from '../graphql/AdminReports';
import { AdminReport, AdminReportsDocument } from '../graphql/types';
import ReportCard, { ReportCardProps } from '../elements/ReportCard';

const AdminReports: FunctionComponent = () => {

  // lazy load reports
  const { query: getReports, pending, failed, results: reports } = useQueryCounted({
    data: undefined as unknown as AdminReport,
    key: 'adminReports',
    lazyQuery: useLazyQuery(ADMIN_REPORTS_QUERY as typeof AdminReportsDocument)
  });

  useEffect(() => {
    getReports?.();
  }, [getReports]);

  const componentProps: Partial<ReportCardProps> = useMemo(() => ({}), []);

  return (
    <CardsGrid
        items={reports}
        variant="white"
        withReloading
        notFoundMessage="admin.reports.empty"
        withoutTopPadding
        disabled={pending}
        pending={pending}
        failed={failed}
        component={ReportCard}
        ComponentProps={componentProps}
    />
  );
};

export default memo(AdminReports);
